import React from 'react';
import NetworkErrorPage from '@/components/NetworkErrorPage';

class RouteErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[RouteErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) return <NetworkErrorPage />;
    return this.props.children;
  }
}

export default RouteErrorBoundary;
